module.exports = __webpack_public_path__ + "static/media/galerija_2014 (13).760db05c.jpg";